import React from 'react';
import styled from 'styled-components';
import { token } from '@bynder/design-system';
import GuideOwner from './GuideOwner';
import BulletPoint from '../shared/BulletPoint';
import GuideSavingStatus from './GuideSavingStatus';

interface Props {
  authorId: string;
}

const HeaderSubtitle: React.FC<Props> = ({ authorId }) => (
  <StyledHeaderSubtitle>
    <GuideOwner authorId={authorId} />
    <BulletPoint />
    <GuideSavingStatus />
  </StyledHeaderSubtitle>
);

const StyledHeaderSubtitle = styled.span`
  display: flex;
  align-items: center;
  color: ${token.gray600a};
  height: 20px;

  & > span {
    padding: 0 ${token.spacing2};
  }
`;

export default HeaderSubtitle;
